import { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useSWR from "swr"

import { OrderContext } from "../../../../context/OrderContext";

import { api } from "../../../../api/api";
import { mascaraMoeda, maskCurrency } from "../../../../utils/utils";

import { FaMinus, FaPlus } from "react-icons/fa";
import { isMobile } from "react-device-detect";

export function NewAddProduct() {
  const { orderScreen, changeOrderScreen,
    setConfirmationProducts, productSelect,
    setProductSelect, selects, setSelects,
    clearSelect
  } = useContext(OrderContext)

  const [categorySelect, setCategorySelect] = useState('sem-categoria')
  const [filterProduct, setFilterProduct] = useState('')

  const { data: categories } = useSWR('/category', async () => {
    const response = await api.get('/category')
    return response.data
  }, { refreshInterval: 15000, refreshWhenHidden: true })

  const { data: products } = useSWR('/products', async () => {
    const response = await api.get('/products')
    return response.data.data
  }, { refreshInterval: 15000, refreshWhenHidden: true })

  const { data: categoriesAdditinal } = useSWR(['/category/additional/products/', productSelect?.id], async (productId) => {
    if (!productId || productId.length === 0 || !productId[1]) {
      return []
    }
    const response = await api.get(`/category/additional/products/${productId[1]}`)
    return response.data
  })

  function plusOrLessQuantityAdditional(additional, categoryAdditionalName, quantity, category) {
    const max = category.max === 0 ? Infinity : category.max;
    const _name = categoryAdditionalName.replace(/ /g, '_');

    setSelects((prevSelects) => {
      const prevAdditional = prevSelects.additinal || {};
      const currentCategoryItems = prevAdditional[_name] || [];

      const actual = currentCategoryItems.find(e => e.id === additional.id);
      const additionalQuantities = currentCategoryItems.reduce((sum, item) => sum + item.quantity, 0);

      if (quantity > 0) {
        if (additionalQuantities >= max) return prevSelects;
        if (currentCategoryItems.length >= max && !actual) return prevSelects;
      }

      let newCategoryItems;

      if (!actual) {
        if (quantity <= 0) return prevSelects;

        newCategoryItems = [
          ...currentCategoryItems,
          {
            id: additional.id,
            name: additional.name,
            pricing: parseFloat(additional.pricing),
            quantity: quantity,
            useHighestItemPrice: category.useHighestItemPrice
          }
        ];
      } else {
        const newQuantity = actual.quantity + quantity;

        if (newQuantity <= 0) {
          newCategoryItems = currentCategoryItems.filter(e => e.id !== additional.id);
        } else {
          newCategoryItems = currentCategoryItems.map(e =>
            e.id === additional.id ? { ...e, quantity: newQuantity } : e
          );
        }
      }

      return {
        ...prevSelects,
        additinal: {
          ...prevAdditional,
          [_name]: newCategoryItems
        }
      };
    });
  }

  useEffect(() => {
    if (orderScreen.listProducts) {
      clearSelect()
      setProductSelect('')
      setConfirmationProducts(false)
    }
  }, [orderScreen.listProducts])

  return (
    <>
      <div className="order-product-editor" style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
        <div className={`order-product-categories ${productSelect ? 'configuring-product' : ''}`} style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          flex: 1,
          maxWidth: !productSelect ? '35%' : '100%',
          borderRight: 'solid 1px #f1f5f9',
          padding: '1rem',
          backgroundColor: productSelect ? 'white' : '#f8fafc80'
        }}>
          {!productSelect && (
            <div>
              <p style={{ color: '#94a3b8', fontSize: 'var(--font-size-subtitle)', fontWeight: '600' }}>CATEGORIAS</p>
              <select
                className="order-mobile-category-select"
                value={categorySelect}
                onChange={(event) => setCategorySelect(event.target.value)}
                aria-label="Selecionar categoria"
              >
                {_.orderBy(categories, 'name', 'asc')
                  ?.concat({ name: 'Sem categoria', id: 'sem-categoria', active: true })
                  ?.filter(category => Boolean(category.active))
                  ?.map(category => <option key={category.id} value={category.id}>{category.name}</option>)}
              </select>
            </div>
          )}

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.3rem',
          }}>
            <div>
              <>
                {!productSelect && (
                  <div className="order-category-list" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    overflow: 'auto',
                  }}>
                    {/* <select onChange={(e) => setCategorySelect(e.target.value)} value={categorySelect} className="mt-2 form-select">
                        {
                          _.orderBy(categories, 'name', 'asc')
                            ?.concat({ name: 'Sem categoria', id: 'sem-categoria', color: 'bg-dark', active: true })
                            ?.filter(e => Boolean(e.active))
                            ?.map(e => <option key={e.id} value={e.id}>{e.name}</option>)
                        }
                      </select> */}
                    {
                      _.orderBy(categories, 'name', 'asc')
                        ?.concat({ name: 'Sem categoria', id: 'sem-categoria', color: 'bg-dark', active: true })
                        ?.filter(e => Boolean(e.active))
                        ?.map(e =>
                          <div
                            key={e.id}
                            value={e.id}
                            onClick={() => setCategorySelect(e.id)}
                            style={{
                              backgroundColor: `${categorySelect === e.id ? '#121428' : 'transparent'}`,
                              borderRadius: '8px',
                              padding: '0.8rem 1rem',
                              color: '#252424',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              cursor: 'pointer',
                            }}>
                            <p style={{ fontSize: 'var(--font-size-body)', fontWeight: '600', color: `${categorySelect === e.id ? 'white' : '#475569'}` }}>{e.name}</p>
                          </div>
                        )
                    }
                  </div>
                )}

                {productSelect && orderScreen.addProducts && (
                  <div>
                    <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', marginTop: '0.8rem' }}>
                      <h4 className="text-gray">{productSelect.name.charAt(0).toUpperCase() + productSelect.name.slice(1)}</h4>
                    </div>

                    {categoriesAdditinal?.length ? (
                      <div className="col-sm-12 mt-2 row" style={{ overflow: 'auto', maxHeight: 300 }}>
                        {categoriesAdditinal?.sort((a, b) => a.assortment - b.assortment)?.map((item) => {
                          const nameCategory = item.name.split(' ').join('_')

                          return (
                            <div key={item.id}>
                              <ul className="list-group mt-3 mb-3">
                                <li
                                  className="d-flex align-items-center justify-content-between"
                                  style={{
                                    border: 'none',
                                    backgroundColor: '#f8fafc',
                                    boxShadow: '0 0 0 1px #e4ebf7',
                                    borderRadius: '8px',
                                    padding: '0.8rem 1rem',
                                    marginBottom: '1rem',
                                    fontWeight: 600,
                                    color: '#121428'
                                  }}
                                  aria-current="true">
                                  <span className="text-gray">{nameCategory.replace(/_/ig, ' ')}</span>
                                  <span className="fw-bold" style={{ color: '#ff6200', fontSize: 'var(--font-size-subtitle)' }}><i>min</i> ({item.min}) - <i>max</i> ({item.max})</span>
                                </li>

                                {item.additionals.map((value) => {
                                  const additionalSelect = selects.additinal[nameCategory]?.find(e => e.id === value.id)

                                  return (
                                    <li
                                      className="d-flex align-items-center justify-content-between"
                                      key={value.id}
                                      style={{
                                        border: 'none',
                                        boxShadow: '0 0 0 1px #e4ebf7',
                                        borderRadius: '8px',
                                        padding: '0.8rem 1rem',
                                        marginBottom: '0.5rem',
                                        color: '#121428'
                                      }}
                                    >
                                      <div>
                                        <p style={{
                                          fontWeight: 600,
                                        }}
                                        >
                                          {value.name}
                                        </p>

                                        <p style={{ color: '#ff6200', fontWeight: 500, fontSize: 'var(--font-size-body)' }}>
                                          + {maskCurrency(value.pricing)}
                                        </p>
                                      </div>

                                      <div style={{ boxShadow: '0 1px 2px 0 #e4ebf7', border: 'solid 1px #e4ebf7', borderRadius: 8, padding: '0.5rem 0.8rem' }}>
                                        <p>
                                          <span className={`${isMobile ? 'fs-2' : 'fs-7'} me-2 pointer`} style={{ color: '#252424' }} onClick={() => plusOrLessQuantityAdditional(value, item.name, -1, item)}>
                                            <FaMinus />
                                          </span>

                                          <span className={`${isMobile ? 'fs-2' : 'fs-7'}`} style={{ marginLeft: 10, marginRight: 10, fontWeight: 600, userSelect: 'none' }}>{additionalSelect?.quantity || 0}</span>

                                          <span className={`${isMobile ? 'fs-2' : 'fs-7'} ms-2 pointer`} style={{ color: '#252424' }} onClick={() => plusOrLessQuantityAdditional(value, item.name, 1, item)}>
                                            <FaPlus />
                                          </span>
                                        </p>
                                      </div>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          )
                        })}
                      </div>
                    ) : ''}

                    <hr style={{ color: 'rgb(176, 185, 202)' }} />

                    <div className="row">
                      {productSelect && (
                        <>
                          <div className="col-sm-6">
                            <label htmlFor="" style={{ fontWeight: 600, color: '#121428' }}>QUANTIDADE</label>
                            <input
                              type="number"
                              value={selects?.quantity ?? 0}
                              className="form-control form-control-sm"
                              style={{ borderRadius: 8, height: '32px', fontSize: 'var(--font-size-input)', backgroundColor: '#f9fafb', border: 'solid 1px rgb(228, 235, 247)', fontWeight: 500, color: '#121428' }}
                              onChange={(e) => {
                                setSelects(state => {
                                  return {
                                    ...state,
                                    quantity: e.target.value ?? 1
                                  }
                                })
                              }} />
                          </div>

                          <div className="col-sm-6">
                            <label htmlFor="" style={{ fontWeight: 600, color: '#121428' }}>VALOR</label>
                            <input
                              type="text"
                              value={maskCurrency((selects.promotionalPrice || selects?.pricing) ?? 0)}
                              className="form-control form-control-sm"
                              style={{ borderRadius: 8, height: '32px', fontSize: 'var(--font-size-input)', backgroundColor: '#f9fafb', border: 'solid 1px rgb(228, 235, 247)', fontWeight: 500, color: '#121428' }}
                              onChange={(e) => {
                                setSelects(state => {
                                  return {
                                    ...state,
                                    pricing: mascaraMoeda(e.target.value ?? '0')
                                  }
                                })
                              }} />
                          </div>

                          <div className="col-sm-12 mt-3">
                            <label htmlFor="" style={{ fontWeight: 600, color: '#121428' }}>DESCRIÇÃO</label>

                            <textarea
                              rows={3}
                              cols={3}
                              value={selects?.observation}
                              className="form-control form-control-sm"
                              placeholder="Ex: Sem cebola, bem passado..."
                              style={{ borderRadius: 8, fontSize: 'var(--font-size-input)', backgroundColor: '#f9fafb', border: 'solid 1px rgb(228, 235, 247)', fontWeight: 500, color: '#121428' }}
                              onChange={(e) => {
                                setSelects(state => {
                                  return {
                                    ...state,
                                    observation: e.target.value
                                  }
                                })
                              }} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </>
              {/* {(confirmationProducts && listProductsAdd.length > 0) && (
                <div className="mt-3">
                  <hr />
                  <h3 className="text-center">Lista de produtos</h3>
                  <ListProducts
                    products={listProductsAdd} removeProduct={async (id) => {
                      const confirm = await Toast.confirm()

                      if (confirm) {
                        setListProductsAdd(listProductsAdd.filter((e) => e.id !== id))
                      }
                    }} />

                  <div className="mt-5" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <button className="btn btn-sm btn-outline-primary ms-3" onClick={() => addProduct(listProductsAdd, { print: true })}>
                      Confirmar
                    </button>
                    <button className="btn btn-sm btn-dark ms-3" onClick={() => setConfirmationProducts(false)}>
                      Voltar e adicionar mais produtos
                    </button>
                  </div>
                </div>
              )} */}
            </div>
          </div>
        </div>

        {!productSelect && (
          <div className="order-product-catalog" style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '1rem 1rem 0 1rem' }}>
            <div>
              <input
                type="text"
                value={filterProduct}
                onChange={(x) => setFilterProduct(x.target.value)}
                placeholder="Buscar Produto..."
                className="form-control form-control-sm"
                style={{ borderRadius: 8, height: '35px', fontSize: 'var(--font-size-input)' }}
              />
            </div>

            <div className="mt-2 card-pai-product order-product-grid" style={{ overflow: 'auto', height: 340, padding: '10px 0 10px 0', borderRadius: 5, display: 'grid', gridTemplateColumns: "1fr 1fr", flex: 1, gap: 10 }}>
              {products?.filter(e => {
                if (!Boolean(e.active)) {
                  return false
                }

                if ((e.categoryId === null ? 'sem-categoria' : e.categoryId) === categorySelect) {
                  return true
                }

                return false
              }).filter(e => e.name.toLowerCase().includes(filterProduct.toLowerCase())).map((e => {
                return (
                  <div key={e.id} className="card pointer card-product" style={{ borderRadius: 8, maxHeight: '200px' }} onClick={() => {
                    setProductSelect(e)
                    setFilterProduct('')
                    changeOrderScreen('addProducts')
                    setSelects(state => {
                      return {
                        ...state,
                        idProduct: e?.id,
                        nameProduct: e?.name,
                        pricing: e?.pricing,
                        promotionalPrice: e.promotionalPrice,
                        quantity: 1,
                        idSector: e.idSector
                      }
                    })
                  }}>
                    <img
                      loading="lazy"
                      width={108}
                      height={124}
                      src={e.image || 'https://pedidos-images.s3.amazonaws.com/default/image-default.png'}
                      className={`card-img-top ${e.image ? 'product-image' : 'product-image-placeholder'}`}
                      alt={e.name}
                    />
                    <div className="card-body">
                      <p className="card-title text-gray">{e.name.charAt(0).toUpperCase() + e.name.slice(1)}</p>
                    </div>
                  </div>
                )
              }))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}
